import React, {useEffect, useState} from "react";

const DISMISSED_KEY = "pwa-install-banner-dismissed";

const isIOS = () =>
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const isStandalone = () =>
    window.matchMedia("(display-mode: standalone)").matches ||
    navigator.standalone === true;

const PwaInstallBanner = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showIOSHint, setShowIOSHint] = useState(false);
    const [dismissed, setDismissed] = useState(
        () => localStorage.getItem(DISMISSED_KEY) === "1"
    );

    useEffect(() => {
        if (isStandalone() || dismissed) return;

        if (isIOS()) {
            setShowIOSHint(true);
            return;
        }

        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };
        window.addEventListener("beforeinstallprompt", handler);
        return () => window.removeEventListener("beforeinstallprompt", handler);
    }, [dismissed]);

    const handleInstall = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const {outcome} = await deferredPrompt.userChoice;
        if (outcome === "accepted") {
            setDeferredPrompt(null);
        }
    };

    const handleDismiss = () => {
        localStorage.setItem(DISMISSED_KEY, "1");
        setDismissed(true);
        setDeferredPrompt(null);
        setShowIOSHint(false);
    };

    const visible = !dismissed && !isStandalone() && (deferredPrompt || showIOSHint);

    useEffect(() => {
        document.documentElement.style.setProperty(
            "--pwa-banner-height",
            visible ? "44px" : "0px"
        );
        return () => document.documentElement.style.setProperty("--pwa-banner-height", "0px");
    }, [visible]);

    if (!visible) return null;

    return (
        <div style={{
            position: "fixed",
            top: "var(--navbar-height, 56px)",
            left: 0,
            right: 0,
            zIndex: 1050,
            background: "#e8f4fd",
            borderBottom: "1px solid #b3d4ec",
            padding: "10px 16px",
            display: "flex",
            alignItems: "center",
            gap: 12,
            fontSize: "0.88rem",
            color: "#15395b",
        }}>
            <span style={{fontSize: "1.1rem"}}>📱</span>
            {showIOSHint ? (
                <span style={{flex: 1}}>
                    App installieren: Tippen Sie auf{" "}
                    <span style={{fontWeight: 700}}>⬆</span> und dann{" "}
                    <span style={{fontWeight: 700}}>„Zum Home-Bildschirm"</span>
                </span>
            ) : (
                <>
                    <span style={{flex: 1}}>
                        Diese App lässt sich direkt auf dem Startbildschirm installieren.
                    </span>
                    <button
                        onClick={handleInstall}
                        style={{
                            background: "#1d5fa8",
                            color: "#fff",
                            border: "none",
                            borderRadius: 6,
                            padding: "5px 12px",
                            fontWeight: 600,
                            fontSize: "0.82rem",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Installieren
                    </button>
                </>
            )}
            <button
                onClick={handleDismiss}
                aria-label="Schließen"
                style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "1.1rem",
                    lineHeight: 1,
                    cursor: "pointer",
                    color: "#4a5d72",
                    padding: "2px 4px",
                    flexShrink: 0,
                }}
            >
                ✕
            </button>
        </div>
    );
};

export default PwaInstallBanner;
